import React from 'react';
import { AnimatedSection } from './AnimatedSection';
import { CTAButton } from './CTAButton';
import { motion } from 'framer-motion';
export function PricingSection() {
  return <section id="pricing" className="py-20 px-6 md:px-8 max-w-2xl mx-auto text-center" data-id="element-182">
      <AnimatedSection data-id="element-183">
        {/* Product Mockup */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="mb-10 flex justify-center" data-id="element-184">
          <img src="https://cdn.magicpatterns.com/uploads/qBUYsrjBDTf7ZorQC4156f/heylloyd-image-1771129581573.png" alt="Devoción sin Culpa — ebook digital" className="w-full max-w-xs rounded-sm shadow-lg shadow-bark/10" data-id="element-185" />
        </motion.div>

        <div className="border-2 border-gold/20 p-8 md:p-12 rounded-sm bg-white/40 backdrop-blur-sm" data-id="element-186">
          <h2 className="text-5xl md:text-6xl font-serif text-bark mb-2" data-id="element-187">
            AR$ 9.300
          </h2>
          <p className="text-bark/60 mb-8" data-id="element-188">Pago único • Acceso inmediato</p>

          <div className="space-y-2 text-lg text-bark/80 mb-10 font-serif" data-id="element-189">
            <p data-id="element-190">Acceso inmediato al PDF</p>
            <p data-id="element-191">+</p>
            <p data-id="element-192">Calendario de 21 días</p>
            <p data-id="element-193">+</p>
            <p data-id="element-194">Guiones listos</p>
          </div>

          <CTAButton className="text-xl px-10 py-5" href="https://argrutinas.com/cart/42973433626833:1" data-id="element-195">
            Quiero empezar hoy
          </CTAButton>

          <p className="mt-4 text-sm text-bark/50" data-id="element-196">
            Compra segura. Entrega digital inmediata.
          </p>
        </div>
      </AnimatedSection>
    </section>;
}